// import React from "react";

// function TextHeader({ headerImg, headerText, headerDesc ,headerDescClass,alt,post_date}) {
    
//   const options = {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric',
//   };
   
   
//   return (
//     <div className="text-card gap-3">

//     <div style={{width:"120px"}}>
//     <img
//         src={headerImg}
//         alt={alt}
//         loading="lazy"
//         className="headerImg"
//         width="120"
//         height="80"
//       />
//     </div>
//       <div className="main-text" style={{ width: "100%" }}>
//         <h5 className="headerText fw-bold line-clamp">{headerText}</h5>
//         <p className={`text-black header-desc ${headerDescClass}`}  style={{fontSize:"12px",paddingBottom:"-10px",marginTop:"-20px"}}>
//         By <span className="fw-bold">{headerDesc}</span> | {new Date(post_date).toLocaleDateString(undefined, options) }  
//         </p>
//       </div>
   
//     </div>
//   );
// }

// export default React.memo(TextHeader);

import React from "react";

function TextHeader({ headerImg, headerText, headerDesc, headerDescClass, alt, post_date }) {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  return (
    <div className="text-card gap-3">
      {/* Image wrapper – fixed width so it never stretches */}
      <div className="img-wrapper">
        <img
          src={headerImg}
          alt={alt}
          loading="lazy"
          className="headerImg"
          width="120"
          height="80"
        />
      </div>

      {/* Text wrapper – takes the remaining space */}
      <div className="main-text">
        <h5 className="headerText fw-bold line-clamp">{headerText}</h5>
        <p
          className={`text-black header-desc ${headerDescClass}`}
          style={{ fontSize: "12px", paddingBottom: "-10px", marginTop: "-20px" }}
        >
          By <span className="fw-bold">{headerDesc}</span> |{" "}
          {new Date(post_date).toLocaleDateString(undefined, options)}
        </p>
      </div>
    </div>
  );
}

export default React.memo(TextHeader);